"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledWrapper = exports.StyledButton = void 0;

var _reactEmotion = _interopRequireWildcard(require("react-emotion"));

var _emotionTheming = require("emotion-theming");

var buttonStyles = function buttonStyles(_ref) {
  var theme = _ref.theme;
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("display:inline-flex;align-items:center;justify-content:center;width:35px;fill:", theme.color.black3, ";cursor:pointer;transition:fill 0.25s;&:hover{fill:", theme.color.accentHover, ";}&:active{fill:", theme.color.accentClicked, ";}svg{width:14px;height:14px;}")
  );
};

var StyledButton = (0, _emotionTheming.withTheme)(
/*#__PURE__*/
(0, _reactEmotion.default)("div", {
  target: "css-obr82i0"
})(buttonStyles));
exports.StyledButton = StyledButton;

var wrapperStyles = function wrapperStyles(_ref2) {
  var theme = _ref2.theme;
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("display:inline-flex;align-items:center;justify-content:center;border:1px solid ", theme.color.grey2, ";padding:8px;border-radius:36px;")
  );
};

var StyledWrapper = (0, _emotionTheming.withTheme)(
/*#__PURE__*/
(0, _reactEmotion.default)("div", {
  target: "css-obr82i1"
})(wrapperStyles));
exports.StyledWrapper = StyledWrapper;